var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 61,
    viewBox: "0 0 67 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5866 27.8818C15.7547 29.6983 14.1469 31.1165 13.343 32.7471C12.061 35.355 12.8912 38.5259 14.1837 41.1285C17.8721 48.5858 24.734 53.6635 31.9532 57.9445C33.7396 59.0015 35.9726 57.5408 35.7152 55.4641C35.2003 51.3105 35.4157 47.0614 36.3667 42.9822",
    fill: "#FDAA74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.1277 12.7511C31.8563 12.22 32.5446 10.1857 33.7373 8.81532C35.6446 6.63233 38.8601 6.21274 41.7341 6.43582C49.9568 7.0785 57.1971 11.5879 63.8436 16.7294C65.4881 18.0041 64.989 20.6492 62.9924 21.191C58.994 22.2798 55.1795 24.0804 51.8063 26.5077",
    fill: "#FDAA74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.5608 47.8426C20.7703 40.4119 6.96237 23.92 2.64346 4.95286C2.45957 4.15083 2.34923 3.17354 2.96397 2.63708C3.30549 2.33964 3.77837 2.27059 4.22497 2.21748C22.1836 0.140707 43.9778 13.2387 53.6875 28.6524L38.5608 47.8426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.3445 13.6429C4.22537 10.8225 3.32166 7.92249 2.64387 4.9534C2.45998 4.15138 2.34964 3.17408 2.96438 2.63763C3.3059 2.34019 3.77877 2.27114 4.22538 2.21802C7.89802 1.79311 11.7335 2.01088 15.5901 2.74916C11.8018 5.96258 8.39716 9.6487 5.3445 13.6429Z",
    fill: "#FDB03F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.9959 25.48C15.957 22.408 15.957 17.4274 18.9959 14.3555C22.0347 11.2835 26.9616 11.2835 30.0004 14.3555C33.0392 17.4274 33.0392 22.408 30.0004 25.48C26.9616 28.5519 22.0347 28.5519 18.9959 25.48Z",
    stroke: "#F59F4F",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M64.7854 52.0875C64.1077 46.4893 59.9516 41.4806 54.6187 39.8394C52.4697 39.1755 49.9793 39.0799 48.1245 40.3599C45.3504 42.2827 45.2137 46.6911 47.1315 49.4849C49.0493 52.2788 52.4014 53.7075 55.6853 54.4352C55.349 53.0967 55.4541 51.0943 56.8149 51.0253C57.1932 51.004 57.5557 51.174 57.8973 51.3333C60.4297 52.539 62.9675 53.7447 65.5 54.9504L64.7749 52.0875H64.7854Z",
    fill: "#E65B49"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b55984c106f6f127c0f377dc1b97acab.svg";
export { ForwardRef as ReactComponent };